/**
 * Tracker helper for sharing commonly used types and methods
 */

/** Typed Catalog source, alias "Catalog Type", */
export enum CatalogSource {
  Internal = 'Internal',
  External = 'External',
}
